import * as React from "react";
import { forwardRef } from "react";
const SvgLeftChevron = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10.47 4.94L9.53003 4L5.53003 8L9.53003 12L10.47 11.06L7.4167 8L10.47 4.94Z", fill: "white" }));
const ForwardRef = forwardRef(SvgLeftChevron);
export { ForwardRef as ReactComponent };
